export function LogoIcon(props: { size?: number }) {
  const size = props.size || 24

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.4324 23.1164H7.56252C6.45252 23.1164 5.41337 22.5158 4.85331 21.5509L0.420046 13.872C-0.140015 12.907 -0.140015 11.7093 0.420046 10.7444L4.85331 3.06547C5.40999 2.10055 6.44914 1.5 7.56252 1.5H17.5593L13.9054 7.7484H9.81626C9.53623 7.7484 9.27644 7.89685 9.13812 8.13977L6.95522 11.9185C6.8169 12.158 6.8169 12.4583 6.95522 12.7012L9.13812 16.48C9.27644 16.7195 9.53623 16.8713 9.81626 16.8713H13.9088L17.4952 23.1164H16.4324ZM7.56252 2.51216C6.81015 2.51216 6.10838 2.91702 5.73051 3.57155L1.29725 11.2505C0.919378 11.9016 0.919378 12.7147 1.29725 13.3659L5.73051 21.0448C6.10838 21.6993 6.81015 22.1042 7.56252 22.1042H15.761L13.3251 17.8835H9.81626C9.17523 17.8835 8.58143 17.5394 8.26091 16.986L6.07802 13.2073C5.7575 12.654 5.7575 11.9657 6.07802 11.4124L8.26091 7.63369C8.58143 7.08037 9.17523 6.73624 9.81626 6.73624H13.3183L15.7543 2.51216H7.55915H7.56252Z'
        fill='#868686'
      />
      <path
        d='M18.5276 22.4147L15.0019 16.2439L17.0431 12.7048C17.1814 12.4618 17.1814 12.1649 17.0431 11.922L14.9985 8.37946L18.6052 2.12769L19.1416 3.06225L23.5884 10.7648C24.1383 11.7162 24.1383 12.9139 23.5816 13.8789L21.3043 17.8229L18.5343 22.4114L18.5276 22.4147ZM16.1693 16.2439L18.6052 20.468L22.7011 13.3728C23.0789 12.7216 23.0789 11.9085 22.7011 11.2574V11.2506L18.6018 4.15538L16.1659 8.37946L17.9203 11.4159C18.2408 11.9693 18.2408 12.6575 17.9203 13.2108L16.1693 16.2439Z'
        fill='#868686'
      />
    </svg>
  )
}
